import { ReactNode } from "react"
import * as toastify from "react-toastify"

export const showToast = (
  message: string | (string | ReactNode)[],
  options?: toastify.ToastOptions
) => {
  const defaultOptions: toastify.ToastOptions = {
    ...options,
    bodyStyle: {
      color: "black",
      ...options?.bodyStyle,
    },
    position: options?.position ?? "top-right",
    autoClose: options?.autoClose ?? 8000,
    hideProgressBar: options?.hideProgressBar ?? true,
    closeOnClick: options?.closeOnClick ?? true,
    pauseOnHover: options?.pauseOnHover ?? true,
    draggable: options?.draggable ?? true,
    progress: options?.progress ?? undefined,
    transition: options?.transition ?? toastify.Slide,
  }

  return toastify.toast(
    <>
      {typeof message === "string" && <span>{message}</span>}
      {typeof message !== "string" &&
        (message as (string | ReactNode)[]).map((m, i) => {
          return i === 0 ? <span key={i}>{m}</span> : <p key={i}>{m}</p>
        })}
    </>,
    defaultOptions
  )
}

export const showWarnToast = (
  message: string | (string | ReactNode)[],
  options?: toastify.ToastOptions
) => {
  const defaultOptions: toastify.ToastOptions = {
    ...options,
    bodyStyle: {
      color: "black",
      ...options?.bodyStyle,
    },
    type: "warning",
    position: options?.position ?? "top-right",
    autoClose: options?.autoClose ?? 8000,
    hideProgressBar: options?.hideProgressBar ?? true,
    closeOnClick: options?.closeOnClick ?? true,
    pauseOnHover: options?.pauseOnHover ?? true,
    draggable: options?.draggable ?? true,
    progress: options?.progress ?? undefined,
    transition: options?.transition ?? toastify.Slide,
  }

  return toastify.toast(
    <>
      {typeof message === "string" && <span>{message}</span>}
      {typeof message !== "string" &&
        (message as (string | ReactNode)[]).map((m, i) => {
          return i === 0 ? <span key={i}>{m}</span> : <p key={i}>{m}</p>
        })}
    </>,
    defaultOptions
  )
}
